const INS_DOCUMENT_EXPIRY_DATE_LIMIT = 30;

export default INS_DOCUMENT_EXPIRY_DATE_LIMIT;
